import 'regenerator-runtime/runtime';
import { call, cancel, put, takeEvery } from 'redux-saga/effects';
import {
  ANTRAGSNUMMER_EVENTS,
  DoRequestResponse,
  GlobalActions,
  GlobalPut,
} from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';
import { App } from '@ps20-frontend/frontend-models';
import { PS20Logger } from '@ps20-frontend/logging';
import { safeSaga } from '@ps20-frontend/safe-saga';
import { RsActions } from '../rsActions';

export function* watchAntragsnummerRequested() {
  yield takeEvery(GlobalActions.ANTRAGSNUMMER_REQUESTED, safeSaga(antragsnummerSaga, App.RS));
  yield takeEvery(RsActions.VORSCHLAGDATEN_CHANGED, safeSaga(antragsnummerSaga, App.RS));
  yield takeEvery(
    ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
    safeSaga(successCallback, App.RS),
  );
}

export function* antragsnummerSaga(action: AnyAction) {
  if (action.payload?.appId === App.RS || action.type === RsActions.VORSCHLAGDATEN_CHANGED) {
    const globalPut = GlobalPut.getInstance();

    yield call(
      globalPut.put,
      new GlobalActions().doRequestAntragsnummer(
        App.RS,
        ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_SUCCESSFULL,
        ANTRAGSNUMMER_EVENTS.ANTRAGSNUMMER_FAILED,
      ),
    );
  }
}

export function* successCallback(successAction: DoRequestResponse<string>) {
  try {
    if (successAction.doRequestAction.payload.appId === App.RS) {
      const globalPut = GlobalPut.getInstance();
      const antragsnummerAsString = successAction.payload.toString();
      yield put(new RsActions().antragsnummerGenerated(antragsnummerAsString));
      yield call([globalPut, globalPut.put], new GlobalActions().antragsnummerGenerated());
    }
  } catch (exception) {
    PS20Logger.error(
      App.RS,
      exception as Error,
      'antragsnummerSaga successCallback Antragsnummer konnte nicht verarbeitet werden',
    );
    yield cancel();
  }
}
